import { getParameter } from '@hotjar/insights-common/lib/url';
/**
 * Service for Marketing Campaigns (Trial Extensions & Registration).
 */
angular.module('hjApp').service('Campaigns', [
    '$rootScope',
    '$location',
    'Account',
    'ipCookie',
    'Notify',
    'Restangular',
    'restDefaultHandlers',
    'Track',
    'UserData',
    function ($rootScope, $location, Account, ipCookie, Notify, Restangular, restDefaultHandlers, Track, UserData) {
        /********************
         * PUBLIC ACCESS FUNCTIONS
         ********************/

        /**
         * Initialize Trial extensions.
         * 1. Check if there are any campaign IDs to be applied.
         * 2. Attempt to apply the campaign if user is logged in.
         */
        this.initTrialExtensions = function initTrialExtensions() {
            var account = Account.getOwned(),
                hjCampaignId = getCampaignId(true);

            if (UserData.loggedIn && hjCampaignId) {
                // Delete cookies from the cookie store to avoid processing it twice.
                ipCookie.remove('hjCampaignId', { path: '/' });

                // Checks if the user owns an account (only account owners can apply a trial link).
                if (account) {
                    // Attempt applying the campaign to the account.
                    Restangular.one('accounts', account.id)
                        .post('campaigns', { campaign_hash: hjCampaignId })
                        .then(
                            function (res) {
                                if (res.success) {
                                    // Fetch new UserData and apply.
                                    UserData.refreshFromServer(function () {
                                        $rootScope.$broadcast('interfaceLoaded');
                                    });

                                    // Track that a campaign has been applied.
                                    Track.campaignApplied();

                                    // Show a success notification.
                                    Notify.success(
                                        'Success - You have now been upgraded to Hotjar ' +
                                            res.plan.toUpperCase() +
                                            ' for ' +
                                            res.days +
                                            ' days.',
                                        { location: 'central' }
                                    );
                                } else {
                                    // Only show error notification for when the campaign is an extension campaign.
                                    if (res.campaign_type === 'extension') {
                                        Notify.error(
                                            'Sorry - This offer has already been used or you are not eligible.',
                                            { location: 'central' }
                                        );
                                    }
                                }
                            },
                            function (res) {
                                restDefaultHandlers.onError(res);
                            }
                        );
                }
            }
        };

        /*********************
         * PRIVATE FUNCTIONS
         **********************/

        /**
         * Get a campaign id (hash) from either the querystring or cookies.
         *
         * @param setCookie Set to true to store the campign ID as a cookie.
         */
        function getCampaignId(setCookie) {
            var hjCampaignId = getParameter($location.absUrl(), 'c') || ipCookie('hjCampaignId') || null;

            if (setCookie && hjCampaignId) {
                ipCookie('hjCampaignId', hjCampaignId, { path: '/' });
            }

            return hjCampaignId;
        }
    }
]);
